import axios from "axios";
import { showToast } from "../../utils/commonHelper";
export const search_Resumes = async ({
  page = 1,
  page_size = process.env.REACT_APP_JOB_PAGES,
  job_title,
  industry,
  career_level,
  region,
  job_family,
}) => {
  try {
    const baseUrl = `${process.env.REACT_APP_API_BASE}/library/search-resumes`;

    const params = new URLSearchParams();
    params.append("page", page);
    params.append("page_size", page_size);

    if (job_title) params.append("job_title", job_title);
    if (industry) params.append("industry", industry);
    if (career_level) params.append("career_level", career_level);
    if (region) params.append("region", region);
    if (job_family) params.append("job_family", job_family);

    const url = `${baseUrl}?${params.toString()}`;

    console.log('url',url);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Resume fetch failed:", error);
    showToast(error, "error");
    return [];
  }
};

export const autoComplete_job_titles = async (search_term) => {
  try {
    const baseUrl = `${process.env.REACT_APP_API_BASE}/library/autocomplete-job-titles`;
    const params = new URLSearchParams();
    params.append("search_term", search_term);
    params.append("limit", process.env.REACT_APP_JOB_AUTO_COMPLETE_LIMIT);
    const url = `${baseUrl}?${params.toString()}`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    // console.log(response.data);
    return response.data.job_titles;
  } catch (error) {
    console.error("Auto complete job titles fetch failed:", error);
    showToast(error, "error");
    return [];
  }
};
